// What setupStatus the main-vendo wizard commits when the operator leaves the
// final step.
//
// Extracted so it can be unit-tested without mounting the whole wizard (which
// needs the full react-query + store provider stack) — same reason as
// subVendoDoneView.ts next to it.
//
// The rule: a step is only allowed to hold the setup open if the ROUTER is not
// finished without it. Applying the config and pushing the portal qualify — a
// vendo missing either one cannot serve a customer. Flashing the NodeMCU does
// not. It used to be checked first and outrank both, so skipping it (a
// supported choice, the flasher has its own Skip) filed a fully working router
// as unfinished: the wizard said "Device registered … is ready" while its
// button said "Save & continue later", and the device list showed Setup in
// progress. The NodeMCU can be flashed later from Device Settings -> Hardware.

import { type SetupStatus } from '@/api/vendo';

export interface RegisterProgress {
   /** True once the router config apply has come back applied. */
   routerApplied: boolean;
   /** True once login.html has been pushed to the router. */
   portalPushed: boolean;
}

export function computeRegisterFinalStatus({
   routerApplied,
   portalPushed,
}: RegisterProgress): SetupStatus {
   if (!routerApplied) return 'configuring-router';
   if (!portalPushed) return 'connecting-portal';
   return 'done';
}

/**
 * May the operator leave the "Flash NodeMCU" step? Yes once the NodeMCU is
 * flashed — or once they have said they will flash it later. Ray 2026-09-29:
 * some operators register the router first and get the NodeMCU afterwards;
 * the flasher's own Skip only appears in browsers that cannot flash at all,
 * so a Chrome user was stuck on this step with no way past it.
 */
export const canLeaveFlashStep = (flashed: boolean, flashLater: boolean): boolean =>
   flashed || flashLater;
